import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MantineProvider } from '@mantine/core';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './util/ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="308106363334-ab3rsun124hi9k14kfi0bm0f50m1i7v9.apps.googleusercontent.com">
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <BrowserRouter>
        <ScrollToTop/>
        <App /> 
      </BrowserRouter>
    </MantineProvider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
